module.exports = __webpack_public_path__ + "static/img/6-4.fbfad362.jpg";